<template>
  <el-container class="main-layout">
    <!-- 桌面端侧边栏 -->
    <el-aside v-if="!isMobile" width="200px" class="sidebar">
      <div class="sidebar-logo">
        <img src="../assets/logo.png" alt="Logo">
        <div class="sidebar-title">深海冒险</div>
      </div>

      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="#4A5568"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
      >
        <el-menu-item
          v-for="item in menuItems"
          :key="item.index"
          :index="item.index"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 移动端抽屉菜单 -->
    <el-drawer
      v-if="isMobile"
      :visible.sync="drawerVisible"
      direction="ltr"
      :with-header="false"
      size="240px"
      class="mobile-drawer"
    >
      <div class="sidebar-logo drawer-logo">
        <img src="../assets/logo.png" alt="Logo">
        <div class="sidebar-title">布丁数字</div>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        background-color="#4A5568"
        text-color="#fff"
        active-text-color="#ffd04b"
        router
        @select="drawerVisible = false"
      >
        <el-menu-item
          v-for="item in menuItems"
          :key="item.index"
          :index="item.index"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </el-drawer>

    <el-container class="main-content">
      <el-header class="main-header">
        <div class="header-left">
          <el-button
            v-if="isMobile"
            type="text"
            icon="el-icon-s-fold"
            class="menu-toggle"
            @click="drawerVisible = true"
          />
          <div class="header-title">
            <i class="el-icon-star-on"></i>
            <span>{{ currentPageTitle }}</span>
          </div>
        </div>

        <div class="user-info">
          <el-dropdown @command="handleUserCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
              <span class="username-text">{{ username || '用户' }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人资料</el-dropdown-item>
              <el-dropdown-item command="settings">设置</el-dropdown-item>
              <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main class="main-body">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import responsiveMixin from '@/mixins/responsive'

const MENU_ITEMS = [
  { index: '/data-dashboard', icon: 'el-icon-data-line', title: '数据大屏' },
  { index: '/ad-revenue', icon: 'el-icon-data-analysis', title: '广告收入' },
  { index: '/system/config', icon: 'el-icon-setting', title: '系统配置', roleOnly: 0 },
  { index: '/user-management', icon: 'el-icon-user-solid', title: '用户管理' },
  { index: '/distribution-account', icon: 'el-icon-wallet', title: '管理员账户', roleOnly: 0 }
]

export default {
  name: 'MainLayout',
  mixins: [responsiveMixin],
  data() {
    return {
      username: localStorage.getItem('username') || '',
      drawerVisible: false
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
    role() {
      return parseInt(localStorage.getItem('role')) || 0
    },
    menuItems() {
      return MENU_ITEMS.filter(item => item.roleOnly === undefined || item.roleOnly === this.role)
    },
    currentPageTitle() {
      const current = MENU_ITEMS.find(item => item.index === this.$route.path)
      return current ? current.title : '欢迎使用'
    }
  },
  methods: {
    handleUserCommand(command) {
      switch (command) {
        case 'logout':
          localStorage.removeItem('token')
          this.$router.push('/login')
          break
        case 'profile':
          this.$message.info('个人资料功能待实现')
          break
        case 'settings':
          this.$message.info('设置功能待实现')
          break
      }
    }
  }
}
</script>

<style scoped>
.main-layout {
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  background-color: #4A5568;
  height: 100%;
  overflow-y: auto;
}

.sidebar-logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  gap: 10px;
  padding: 0 12px;
}

.sidebar-logo img {
  max-height: 30px;
  max-width: 40px;
}

.sidebar-title {
  color: white;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}

.sidebar-menu {
  border: none;
}

.main-content {
  min-width: 0;
  flex: 1;
}

.main-header {
  background-color: white;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  height: 60px !important;
  border-bottom: 1px solid #d8dce5;
}

.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.menu-toggle {
  font-size: 22px;
  color: #4A5568;
  margin-right: 8px;
  padding: 8px;
}

.header-title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  min-width: 0;
}

.header-title i {
  margin-right: 8px;
  color: #409EFF;
  flex-shrink: 0;
}

.header-title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info {
  flex-shrink: 0;
  margin-left: 12px;
}

.el-dropdown-link {
  color: #4A5568;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.username-text {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main-body {
  padding: 20px;
  background-color: #f0f2f5;
  overflow-x: hidden;
  overflow-y: auto;
}

.drawer-logo {
  background-color: #4A5568;
}

@media (max-width: 768px) {
  .main-body {
    padding: 12px;
  }

  .main-header {
    padding: 0 12px;
  }

  .header-title {
    font-size: 15px;
  }

  .username-text {
    max-width: 72px;
  }
}
</style>

<style>
.mobile-drawer .el-drawer__body {
  padding: 0;
  background-color: #4A5568;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
